export class GroupDTO{
  id!: number;
  name!: string;
  description?:string;
  typeId!: number;
  organisationalUnitId!: number;
  isActive?: boolean;
}